/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
/**
 * @internal
 * SVG image with spinner.
 * Color and animation are defined with CSS for `apmui-spinner-image` class.
 */
export default function SpinnerImage(props: { className?: string }) {
    let className = 'apmui-spinner-image';
    if (props.className) {
        className += ' ' + props.className;
    }
    return (
        <svg className={className} version="1.1" viewBox="0 0 40 40">
            <defs>
                <linearGradient x1="1" y1="0" x2="0" y2="1" id="gradient1">
                    <stop stopColor="currentColor" offset="0%" />
                    <stop stopColor="currentColor" stopOpacity="0.9" offset="100%" />
                </linearGradient>
                <linearGradient x1="0" y1="0" x2="1" y2="1" id="gradient2">
                    <stop stopColor="currentColor" stopOpacity="0.9" offset="0%" />
                    <stop stopColor="currentColor" stopOpacity="0.5" offset="100%" />
                </linearGradient>
                <linearGradient x1="0" y1="1" x2="1" y2="0" id="gradient3">
                    <stop stopColor="currentColor" stopOpacity="0.5" offset="0%" />
                    <stop stopColor="currentColor" stopOpacity="0" offset="100%" />
                </linearGradient>
            </defs>
            <path stroke="url(#gradient1)" strokeWidth="4" fill="transparent" d="M20,2C10.1,2,2,10.1,2,20" />
            <path stroke="url(#gradient2)" strokeWidth="4" fill="transparent" d="M2,20C2,29.9,10.1,38,20,38" />
            <path stroke="url(#gradient3)" strokeWidth="4" fill="transparent" d="M20,38C29.9,38,38,29.9,38,20" />
            <circle fill="currentColor" cx="20" cy="2" r="2" />
        </svg>
    );
}
